import { ErrorResponse, ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import qs from 'query-string'
import {
    WorkDay,
    WorkDayPayload,
    WorkdayReportItem,
    WorkdayReportParams,
    SyncEmployeeResult,
} from '../types/response'
import { WorkNDayUpdatePayload } from '../types/payload'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'

export const getAllWorkdays = async (
    payload: DataGridPayload
): Promise<ResponseArray<WorkDay>> => {
    const response = await datacentral.get(
        `/workdays/export_excel_file_with_client_data?${qs.stringify(payload)}`
    )
    return response.data
}

export const getWorkDayByEmployeeID = async (payload: {
    page: number
    page_size: number
    year: number
    month: number
}): Promise<ResponseArray<WorkDay>> => {
    const filters = btoa(
        JSON.stringify({ year: payload.year, month: payload.month })
    )
    const params = {
        page: payload.page,
        page_size: payload.page_size,
        filters: filters,
    }
    const response = await datacentral.get(`/workdays?${qs.stringify(params)}`)
    return response.data
}
export const getTotalWorkDaysByEmployeeID = async (
    payload: WorkDayPayload
): Promise<ResponseObject<WorkDay>> => {
    const response = await datacentral.get<ResponseObject<WorkDay>>(
        `/workdays/total`,
        {
            params: payload,
        }
    )
    return response.data
}

export const UpdateWorkNDay = async (
    payload: WorkNDayUpdatePayload
): Promise<ResponseObject<WorkDay> | ErrorResponse> => {
    const response = await datacentral.put(
        `/workdays/${payload.work_day_id}`,
        payload
    )
    return response.data
}

export interface ExportWorkdaysParams extends DataGridPayload {
    from_year?: number
    from_month?: number
    to_year?: number
    to_month?: number
}

export const exportWorkdays = async (payload: ExportWorkdaysParams) => {
    try {
        const queryString = qs.stringify(payload)

        const response = await datacentral.get(
            `/workdays/export_data?${queryString}`,
            {
                responseType: 'blob',
            }
        )

        return response.data
    } catch (error) {
        console.error('Lỗi khi tải file Excel:', error)
        throw error
    }
}

export const syncWorkdayFile = async (file: File): Promise<any> => {
    try {
        const formData = new FormData()
        formData.append('file', file)

        const response = await datacentral.post('/workdays/sync-data', formData)

        return response.data
    } catch (error) {
        console.error('Lỗi khi đồng bộ file:', error)
    }
}
export const getAllAttendanceSyncLogs = async (
    payload: DataGridPayload
): Promise<ResponseArray<any>> => {
    const response = await datacentral.get(
        `/attendance-sync-logs?${qs.stringify(payload)}`
    )
    return response.data
}

export const getAttendanceSyncLogMetadata = async (
    syncLogID: number
): Promise<ResponseObject<SyncEmployeeResult>> => {
    const response = await datacentral.get(
        `/attendance-sync-logs/${syncLogID}/metadata`
    )
    return response.data
}

export const autoSyncWorkday = async (payload: {
    from_date: string
    to_date: string
}): Promise<any> => {
    const response = await datacentral.post(`/workdays/auto-sync-data`, payload)
    return response.data
}

export const getWorkdaysReport = async (
    params: WorkdayReportParams
): Promise<WorkdayReportItem[]> => {
    const response = await datacentral.get<ResponseArray<WorkdayReportItem>>(
        `/workdays/report?${qs.stringify(params)}`
    )
    return response.data?.results || []
}
